var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfoCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_186",
    "data-name": "Group 186",
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_124",
    "data-name": "Ellipse 124",
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    fill: "#5393d0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1400",
    "data-name": "Path 1400",
    d: "M2.221-17.8A2.208,2.208,0,0,0,4.39-15.631,2.208,2.208,0,0,0,6.558-17.8,2.208,2.208,0,0,0,4.39-19.968,2.208,2.208,0,0,0,2.221-17.8Zm4.137,5.738c0-.767-.1-1.034-.6-1.034a32.949,32.949,0,0,0-4.471.834c-.267.033-.2.434.033.434h.4c1,0,1.4.667,1.468,2.5.033,1.134.133,5.038-.033,7.773C3.022.116,2.622.25,1.888.416c-.2.033-.234.434,0,.434.534,0,2.369-.1,2.9-.1.734,0,2.235.1,3.336.1.267,0,.234-.434,0-.434-1.268-.2-1.6-.3-1.735-1.968C6.225-3.487,6.358-8.425,6.358-12.061Z",
    transform: "translate(12.786 26.059)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircle);
export default __webpack_public_path__ + "static/media/info-circle.b15f482d8bd1b6acada9ba4b42717c4d.svg";
export { ForwardRef as ReactComponent };